import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Menu } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import Sidebar from "@/components/Sidebar";
import Overview from "@/pages/Overview";
import Trucking from "@/pages/Trucking";
import Fleet from "@/pages/Fleet";
import BuildingMaint from "@/pages/BuildingMaint";
import NorthShop from "@/pages/NorthShop";
import Sales from "@/pages/Sales";
import Leads from "@/pages/Leads";
import Units from "@/pages/Units";
import UnitFolder from "@/pages/UnitFolder";

const LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_truck-tracker-66/artifacts/7cv6lzz6_1.png";

function MobileTopBar({ onOpen }) {
  return (
    <div className="lg:hidden sticky top-0 z-30 flex items-center gap-3 bg-[#16265F] px-4 py-3">
      <button onClick={onOpen} data-testid="mobile-menu-btn" className="text-white p-1 -ml-1">
        <Menu className="w-7 h-7" />
      </button>
      <img src={LOGO} alt="Whipp" className="h-9 w-auto" />
      <span className="text-white font-head font-bold uppercase tracking-tight text-lg">Whipp Sales &amp; Service</span>
    </div>
  );
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="App bg-[#F3F4F6]">
      <BrowserRouter>
        <div className="flex min-h-screen">
          <Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
          <div className="flex-1 min-w-0 flex flex-col">
            <MobileTopBar onOpen={() => setMenuOpen(true)} />
            <main className="flex-1 p-4 sm:p-6 lg:p-12 w-full max-w-[1600px]">
              <Routes>
                <Route path="/" element={<Overview />} />
                <Route path="/trucking" element={<Trucking />} />
                <Route path="/fleet" element={<Fleet />} />
                <Route path="/buildings" element={<BuildingMaint />} />
                <Route path="/north-shop" element={<NorthShop />} />
                <Route path="/sales" element={<Sales />} />
                <Route path="/leads" element={<Leads />} />
                <Route path="/units" element={<Units />} />
                <Route path="/units/:id" element={<UnitFolder />} />
              </Routes>
            </main>
          </div>
        </div>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
